import { useContext } from 'react';

import CasesContext from './CasesContext';

const useCases = () => {
  const context = useContext(CasesContext);
  if (context === null) {
    throw new Error('useCases must be used within a CasesProvider');
  }
  return context;
};

export default useCases;
